import { AxiosPromise } from 'axios';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import trainerPaymentFuncs, {
  TrainerPayment,
  Value,
} from '../model/trainerPayment';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '../utils/constants';
import { DefaultBackendHelper } from '../utils/backendHelper';
import { instance, URLS } from '.';
import { isEmptyId } from '../utils/generalUtils';

const logger = new Logger('backend.TrainerPayment');
export interface BackendTrainerPayment {
  getTrainerPayments: (
    searchParams: SearchParams,
    trainerId: string,
    date?: string
  ) => AxiosPromise<Value>;
  deleteTrainerPayment(id: string): AxiosPromise;
  updateTrainerPayment(trainerPayment: TrainerPayment): AxiosPromise<any>;
  checkForOverlappingTrainerPayments(
    trainerPayment: TrainerPayment
  ): AxiosPromise<boolean>;
}

export const defaultBackendTrainerPayment: BackendTrainerPayment = {
  getTrainerPayments(
    searchParams: SearchParams,
    trainerId: string,
    date?: string
  ): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    odfb.eq(CONST.TrainerId, trainerId, false);

    if (date !== undefined) {
      odfb.le(CONST.DateFrom, date, false);
      odfb.ge(CONST.DateTill, date, false);
    }

    let url = DefaultBackendHelper.makeUrl(
      `${URLS.trainerPaymentOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );
    logger.log(`getTrainerPayments: ${url}`);
    return instance.get<Value>(url);
  },

  deleteTrainerPayment(id: string): AxiosPromise {
    logger.debug('deleteTrainerPayment');
    return instance.delete(`${URLS.trainerPayment}/${id}`);
  },
  updateTrainerPayment(trainerPayment: TrainerPayment): AxiosPromise<any> {
    logger.debug('updateTrainerPayment');
    if (!isEmptyId(trainerPayment.id)) {
      return instance.put<TrainerPayment>(
        `${URLS.trainerPayment}/${trainerPayment.id}`,
        trainerPaymentFuncs.toAPI(trainerPayment)
      );
    } else {
      return instance.post<TrainerPayment>(
        `${URLS.trainerPayment}`,
        trainerPaymentFuncs.toAPI(trainerPayment)
      );
    }
  },
  checkForOverlappingTrainerPayments(
    trainerPayment: TrainerPayment
  ): AxiosPromise<boolean> {
    return instance.post<boolean>(`${URLS.trainerPayment}/CheckForOverlap`, {
      TrainerPaymentId: trainerPayment.id || CONST.emptyGuid,
      TrainerId: trainerPayment.trainerId,
      DateFrom: trainerPayment.dateFrom,
      DateTill: trainerPayment.dateTill,
      DepartmentId: trainerPayment.departmentId || null,
    });
  },
};
